import request from '@/utils/request';
import { loginCompany, loginOrg } from '@/utils/LoginContext';

export async function query(payload) {
    return request(`/iwms-wms/wms/shipbill/page`, {
        method: 'POST',
        body: payload,
    });
}

export async function queryUnShipItems(payload) {
    return request(`/iwms-wms/wms/shipbill/unShipItem?shipPlanBillNumber=${payload.shipPlanBillNumber}&dcUuid=${loginOrg().uuid}&waveBillNumber=${payload.waveBillNumbers}`, {
        method: 'POST'
    });
}

export async function pageQueryUnShipItem(payload) {
    return request(`/iwms-wms/wms/shipbill/unShipItem/page`, {
        method: 'POST',
        body: payload,
    });
}

export async function get(payload) {
    return request(`/iwms-wms/wms/shipbill/${payload}`);
}

export async function getByBillNumber(payload) {
    return request(`/iwms-wms/wms/shipbill/bill?billNumber=${payload.billNumber}&dcUuid=${loginOrg().uuid}`);
}

export async function save(payload) {
    return request(`/iwms-wms/wms/shipbill`, {
        method: 'POST',
        body: payload,
    });
}

export async function modify(payload) {
    return request(`/iwms-wms/wms/shipbill/modify`, {
        method: 'POST',
        body: payload,
    });
}

export async function audit(payload) {
    return request(`/iwms-wms/wms/shipbill/audit?billUuid=${payload.uuid}&version=${payload.version}`, {
        method: 'PUT'
    });
}

export async function remove(payload) {
    return request(`/iwms-wms/wms/shipbill/${payload.uuid}?version=${payload.version}`, {
        method: 'DELETE',
    });
}

export async function generateShipBill(payload) {
    let url = `/iwms-wms/wms/shipbill/generateShipBill?companyUuid=${loginCompany().uuid}&dcUuid=${loginOrg().uuid}`;
    if (payload.waveBillNumber) {
        url = url + `&waveBillNumber=${payload.waveBillNumber}`;
    }
    return request(url, {
        method: 'POST',
        body: payload.stores,
    });
}

export async function fastShip(payload) {
    return request(`/iwms-wms/wms/shipbill/fastShip`, {
        method: 'POST',
        body: payload,
    });
}

export async function queryVirtualUnShipItem(payload) {
    return request(`/iwms-wms/wms/shipbill/virtualUnShipItem/page`, {
        method: 'POST',
        body: payload,
    });
}

export async function queryQtyStrInfo(payload) {
    return request(`/iwms-wms/wms/shipbill/queryQtyStrInfo?shipPlanBillNumber=${payload.shipPlanBillNumber}&dcUuid=${loginOrg().uuid}`, {
        method: 'POST',
        body: payload.items,
    });
}
